import { useMutation, useQueryClient } from 'react-query'

import { settingsQueryConfig } from '@webapp/core/query-configs/settings'
import { v1UserQueries } from '@webapp/platform/iam/query-configs/v1UserQueries'
import { type SlackIntegrationError } from '@webapp/platform/integrations/business-logic/errors/SlackIntegrationError'
import { slackIntegrationRepository } from '@webapp/platform/integrations/data-access/repositories/SlackIntegrationRepository'
import { slackIntegrationQueries } from '@webapp/platform/integrations/query-configs/slackIntegrationQueries'

export const useDisconnectSlackIntegrationModel = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<void, SlackIntegrationError, void>({
    mutationFn: () => slackIntegrationRepository.deleteSlackIntegration(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: settingsQueryConfig.getIntegrationStatus().queryKey,
      })
      queryClient.invalidateQueries({
        queryKey: slackIntegrationQueries.all().queryKey,
      })
      queryClient.invalidateQueries({
        queryKey: v1UserQueries.activeUsers().queryKey,
      })
    },
  })

  return {
    disconnect: mutation.mutateAsync,
    isDisconnecting: mutation.isLoading,
  }
}
